// extracted by mini-css-extract-plugin
export var grid = "Grid-module--grid--7bc68";
export var grid__1 = "Grid-module--grid__1--222a6";
export var grid__2 = "Grid-module--grid__2--83665";
export var grid__3 = "Grid-module--grid__3--e1551";
export var grid__4 = "Grid-module--grid__4--45d23";
export var grid__birth = "Grid-module--grid__birth--97175";
export var grid__brand = "Grid-module--grid__brand--7a7f9";
export var grid__footer4 = "Grid-module--grid__footer4--36308";
export var grid__footer6 = "Grid-module--grid__footer6--59269";
export var grid__item = "Grid-module--grid__item--5161b";
export var grid__social = "Grid-module--grid__social--fdfdb";